<template>
  <div class="overflow-hidden rounded-lg border bg-card shadow-sm">
    <iframe
        :src="metabaseUrl"
        title="Dashboard Metabase"
        frameborder="0"
        scrolling="no"
        class="block w-full"
        :height="frameHeight"
        allowtransparency="true"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      frameHeight: 2200,
      metabaseUrl:
        "https://metabase.clafoutis.eu/embed/dashboard/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZXNvdXJjZSI6eyJkYXNoYm9hcmQiOjJ9LCJwYXJhbXMiOnt9LCJpYXQiOjE2MDA4MTA4NDEsIl9lbWJlZGRpbmdfcGFyYW1zIjp7fX0.G5_3Mc4CMT18pmn4fLZPEddhtJabMCDRicfgFcJqUZ4#bordered=false&titled=false",
    };
  },
  mounted() {
    window.addEventListener("message", this.onMetabaseMessage);
  },
  beforeUnmount() {
    window.removeEventListener("message", this.onMetabaseMessage);
  },
  methods: {
    onMetabaseMessage(event) {
      if (typeof event.origin !== "string" || !event.origin.includes("metabase.clafoutis.eu")) return;
      const data = event.data;
      const height = data && (data.height || (data.metabase && data.metabase.height));
      if (typeof height === "number" && height > 200 && Math.abs(height - this.frameHeight) > 24) {
        this.frameHeight = height;
      }
    },
  },
};
</script>
